import { Space, Text } from '@billy/design-system'
import React, { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface EmptyScreenProps {
  headerText?: string
  subText?: string
  img: ReactNode
}

export const EmptyScreen = ({ headerText, subText, img }: EmptyScreenProps): ReactElement => (
  <Styled.EmptyScreenWrapper>
    {img}
    {headerText && (
      <>
        <Space size="s40" />
        <Text variant="h2">{headerText}</Text>
        <Space size="s8" />
      </>
    )}
    {subText && <Text>{subText}</Text>}
  </Styled.EmptyScreenWrapper>
)
